import React, { useEffect, useState} from 'react';
import Layout from "../../../components/mobile/Layout/layoutmobile";
import { useLocation } from '@reach/router';
import { pushtracking } from '../../../service/trackingService';

const Affiliate=()=> {
    const location = useLocation();
    useEffect(() => {
      try{
        pushtracking(window.localStorage.getItem('sessionId')??null,
        window.localStorage.getItem('_id')??null,
        window.localStorage.getItem('phone')??null ,
        location.pathname, "Chính sách bảo hành", 0,0,'index','inWeb',[],'Website PC').then((response)=>{
            // console.log('send tracking');
        });
      }catch(e){console.log(e)}
      
    },[])
    return (
      <Layout>
        {/* <h1 className='d-none'>Chính sách bảo hành</h1> */}
        <div className='container page-builder-ltr'>
          <div className='container-page-footer'>
           
          <p>
      <center>
        <strong>
        ĐIỀU KHOẢN VÀ ĐIỀU KIỆN HỢP TÁC CHƯƠNG TRÌNH AFFILIATE
        </strong>
      </center>
    </p>
    <p>
      Chương trình Tiếp thị liên kết BiboMart được tổ chức bởi Công ty Cổ phần
      BiboMart TM; hoạt động theo Giấy chứng nhận Đăng ký doanh nghiệp số:
      0108024302 được cấp bởi Sở Kế hoạch và Đầu tư thành phố Hà Nội (sau đây
      gọi tắt là “<strong>BiboMart</strong>”); là đơn vị vận hành Nền tảng
      BiboMart theo Thỏa thuận chung về Tiếp thị Liên kết này và/hoặc theo
      chương trình mà BiboMart công bố tại từng thời điểm (“<strong
        >Thỏa thuận Tiếp thị Liên kết</strong
      >”).
    </p>
    <p>
      Tham gia Chương trình Tiếp thị liên kết BiboMart, Bạn sẽ trở thành người
      cung cấp dịch vụ tiếp thị liên kết và nhận lại khoản phí hoa hồng được chi
      trả bởi BiboMart. Điều khoản chung này cùng với bất kỳ chính sách khác
      được công khai trên website của BiboMart và bất kỳ điều khoản và tài liệu
      nào khác được viện dẫn tại Thỏa thuận Tiếp thị Liên kết này có thể được
      sửa đổi, bổ sung hoặc thay thế tùy từng thời điểm (sau đây gọi chung là
      “<strong>Điều khoản Tiếp thị Liên kết</strong>”) được giao kết giữa Bạn và
      BiboMart điều chỉnh việc cung cấp Điều khoản Tiếp thị Liên kết.
    </p>
    <p>
      Bằng cách đăng ký tài khoản để trở thành Người Tiếp thị Liên kết, Bạn được
      xem là đã đồng ý với Thỏa thuận Tiếp thị Liên kết này. Bạn cũng đồng ý
      rằng Thỏa thuận Tiếp thị Liên kết này xác lập như một hợp đồng điện tử, có
      giá trị pháp lý theo quy định của pháp luật.
    </p>
    <p>
      <strong>1. ĐỊNH NGHĨA</strong>
    </p>
    <p>1.1. <strong>Tiếp thị liên kết </strong><em>(TTLK)</em></p>
    <p>
      Là một mô hình quảng bá hàng hóa, sản phẩm của BiboMart mà Người Tiếp thị
      liên kết thực hiện các hoạt động phù hợp thúc đẩy tiếp thị, quảng cáo, thu
      hút người mua mua hàng hóa, sản phẩm của BiboMart và từ đó nhận được hoa
      hồng với mỗi Giao dịch Thành công.
    </p>
    <p>1.2. <strong>Người Tiếp thị Liên kết </strong><em>(Người TTLK)</em></p>
    <p>
      Là các cá nhân, pháp nhân đăng ký tham gia Chương Tiếp thị Liên kết
      BiboMart;
    </p>
    <p>1.3. <strong>Nền tảng BiboMart</strong></p>
    <p>
      Là bất kỳ nền tảng nào được vận hành bởi BiboMart, bao gồm nhưng không
      giới hạn ở website và ứng dụng di động của BiboMart nhằm phục vụ Chương
      trình Bibo Affiliate;
    </p>
    <p>1.4. <strong>Sản Phẩm</strong></p>
    <p>
      Là bất kỳ hàng hóa, sản phẩm nào được đăng tải trên Nền tảng BiboMart để
      bán cho Khách Hàng;
    </p>
    <p>1.5. <strong>Khách Hàng</strong></p>
    <p>Là những người mua Sản Phẩm từ Link Tiếp thị Liên kết.</p>
    <p>1.6. <strong>Tài khoản TTLK</strong></p>
    <p>
      Là tài khoản mà Người TTLK đăng ký sử dụng trên Nền tảng BiboMart và có
      đăng ký tham gia Chương trình Tiếp thị Liên kết BiboMart;
    </p>
    <p>1.7. <strong>Link Tiếp thị Liên kết </strong><em>(Link TTLK)</em></p>
    <p>
      Bao gồm các tài liệu truyền thông/quảng cáo mà BiboMart cung cấp cho Người
      TTLK thông qua Chương trình Tiếp thị Liên kết BiboMart, không giới hạn ở
      hình ảnh, hình vẽ, chữ, các tập tin, đường link URLs và HTML hoặc mã
      Javascript;
    </p>
    <p>
      1.8. <strong>Phương tiện Tiếp thị Liên kết </strong
      ><em>(Phương tiện TTLK)</em>
    </p>
    <p>
      Bao gồm tất cả các phương tiện truyền thông, bao gồm nhưng không giới hạn
      ở các website, ứng dụng di động, cũng như các thư thông (newsletters) của
      Người TTLK, các phương tiện truyền thông do Người TTLK sở hữu hoặc kết nối
      được sử dụng để đăng tải, đính kèm Link TTLK;
    </p>
    <p>1.9. <strong>Giao dịch Thành công</strong></p>
    <p>
      Là giao dịch được Khách Hàng đặt mua Sản Phẩm trực tiếp từ Link TTLK theo
      quy định tại Mục 3.1 Thỏa thuận TTLK này;
    </p>
    <p>1.10. <strong>Phí Hoa hồng</strong></p>
    <p>
      Là loại phí BiboMart trả cho Người TTLK khi có Giao dịch Thành công như
      quy đinh tại Mục 3 Thỏa thuận TTLK này.
    </p>
    <p>
      <strong>
        2. YÊU CẦU KHI THAM GIA CHƯƠNG TRÌNH TIẾP THỊ LIÊN KẾT BIBOMART
      </strong>
    </p>
    <p>
      <strong>2.1. Thông tin đăng ký</strong>
    </p>
    <p>
      (i) Để phục vụ cho việc đăng ký tham gia Chương trình Tiếp thị liên kết
      BiboMart, Người TTLK sẽ cung cấp bất kỳ thông tin nào được BiboMart yêu
      cầu và sẽ đảm bảo các thông tin đó là chính xác và đầy đủ. Bất kỳ trường
      hợp cung cấp thông tin sai lệch hoặc không chính xác nào sẽ là cơ sở để
      BiboMart đơn phương chấm dứt quan hệ hợp tác hoặc hợp đồng và/hoặc thỏa
      thuận (nếu có) với Người TTLK. BiboMart có toàn quyền quyết định chấp nhận
      hoặc từ chối đăng ký của Người TTLK và việc chấp nhận hoặc từ chối đăng ký
      này có thể không cần có lý do.
    </p>
    <p>
      (ii) Nếu quá 1 tháng kể từ thời điểm nhận được yêu cầu của BiboMart về
      việc cung cấp bổ sung thông tin mà Người TTLK không cung cấp hoặc cung cấp
      không đầy đủ thì BiboMart sẽ từ chối thanh toán các khoản Phí Hoa Hồng
      phát sinh kể từ ngày đến hạn theo yêu cầu đã gửi cho đến khi Người TTLK
      hoàn thành nghĩa vụ của mình theo điều khoản này.
    </p>
    <p>
      <strong>2.2. Link Tiếp thị Liên kết</strong>
    </p>
    <p>
      (i) Người TTLK tự chịu trách nhiệm về việc tạo, quảng cáo và quảng bá Sản
      Phẩm (bao gồm quảng cáo hoặc khuyến mãi sử dụng các hoạt động truyền thông
      xã hội của Người TTLK, bao gồm nhưng không giới hạn ở Facebook, Pinterest,
      Twitter, Instagram, Tiktok) (gọi chung là “<strong>Nội Dung TTLK</strong
      >”) và đảm bảo Nội Dung TTLK đó tuân thủ tất cả các chính sách và nguyên
      tắc được thông báo bởi BiboMart tại từng thời điểm.
    </p>
    <p>
      (ii) Link TTLK phải đảm bảo được đăng tải công khai và truy cập được tại
      bất kỳ thời điểm nào mà BiboMart tiến hành hậu kiểm. BiboMart có thể hủy
      tư cách Người TTLK nếu nhận thấy Nội Dung TTLK đi kèm Link TTLK vi phạm
      những điều cầm theo quy định tại Mục 5.2 Thỏa thuận TTLK này hoặc nội dung
      khác mà BiboMart đánh giá là không phù hợp.
    </p>
    <p>
      <strong>3. PHÍ HOA HỒNG VÀ ĐIỀU KHOẢN THANH TOÁN</strong>
    </p>
    <p>
      <strong>3.1. Giao dịch Thành công</strong>
    </p>
    <p>
      Người TTLK chỉ có thể nhận được Phí Hoa Hồng khi Khách Hàng hoàn tất giao
      dịch mua Sản Phẩm trên Nền tảng BiboMart theo quy định của BiboMart thông
      qua việc Khách Hàng truy cập Link TTLK mà Người TTLK đăng tải, chia sẻ, …
      (“<strong>Đơn hàng Trực tiếp</strong>”); không bao gồm các giao dịch đổi
      hàng theo Chính sách Đổi hàng & Hoàn tiền của BiboMart và Khách Hàng:
    </p>
    <p>
      (i) Không phải là một người mua được tạo ra từ hệ thống hoặc phương tiện
      điện tử, ví dụ như robot, phần mềm máy tính hoặc các phương pháp tự động,
      giả lập hoặc không trung thực nhằm làm cho Khách Hàng đó được xem hoặc thể
      hiện như là một cá nhân có thực;
    </p>
    <p>
      (ii) Không bị BiboMart sau đó đánh giá là người dùng giao dịch với dụng ý
      không trung thực, không thỏa các điều kiện của Chương trình Tiếp thị Liên
      kết BiboMart, hoặc tài khoản người dùng thuộc về hoặc có liên quan đến tài
      khoản người dùng khác đã hiện hữu trên Nền tảng BiboMart.
    </p>
    <p>(gọi tắt là “Giao dịch Thành công”).</p>
    <p>
      <strong>3.2. Tỷ lệ Phí Hoa hồng chi trả</strong>
    </p>
    <p>
      (i) Phí Hoa Hồng được tính trên 1 đơn vị Sản Phẩm với giá bán cuối cùng đã
      bao gồm thuế Giá trị gia tăng và sau khi trừ đi các khuyến mãi (được áp
      dụng tại thời điểm thanh toán). Phí vận chuyển đơn hàng không được tính
      vào giá bán Sản Phẩm để làm căn cứ chi trả Phí Hoa Hồng.
    </p>
    <p>
      (ii) Phí Hoa Hồng có thể thay đổi hàng ngày theo chính sách của từng nhãn
      hàng, Sản Phẩm được công bố công khai trên Nền tảng BiboMart. Người TTLK
      có thể truy cập công cụ tra cứu Phí Hoa Hồng để kiểm tra, rà soát Phí Hoa
      Hồng được chi trả.
    </p>
    <p>
      <strong>3.3. Chi trả Phí Hoa Hồng</strong>
    </p>
    <p>
      3.3.1. Mỗi Đơn hàng Trực tiếp phát sinh sẽ gửi thông báo trên Tài khoản
      TTLK và ghi nhận khoản Phí Hoa Hồng dự kiến mà Người TTLK nhận được. Người
      TTLK chỉ có thể rút số tiền này sau khi Đơn hàng Trực tiếp được ghi nhận
      là Giao dịch Thành công.
    </p>
    <p>
      3.3.2. Tối đa trong vòng <strong>45 ngày</strong> kể từ ngày phát sinh Đơn
      hàng Trực tiếp, Phí Hoa Hồng dự kiến sẽ được chuyển về trạng thái khả dụng
      (“<strong>Hoa Hồng Khả Dụng</strong>”). Lúc này, Người TTLK có thể rút Phí
      Hoa Hồng về tài khoản ngân hàng theo thông tin đã đăng ký. BiboMart sẽ chỉ
      tiếp nhận và giải quyết các yêu cầu tra soát Phí Hoa Hồng cho Người TTLK
      trước thời điểm ghi nhận trạng thái Hoa Hồng Khả Dụng.
    </p>
    <p>
      <strong><em>(i) Trường hợp Người TTTLK là cá nhân</em></strong>
    </p>
    <p>
      a. Số tiền rút <strong>tối thiểu: 20.000 VNĐ/lần rút</strong>, Người TTLK
      không bị giới hạn số lần rút Phí Hoa Hồng.
    </p>
    <p>
      b. Căn cứ theo Thông tư 111/2013/TT-BTC của Bộ Tài chính ngày 15/8/2013,
      số tiền Người TTLK nhận được là số tiền sau khi khấu trừ 10% thuế thu nhập
      cá nhân.
    </p>
    <p>
      <strong
        ><em
          >(ii) Trường hợp Người TTTLK là hộ kinh doanh, cá nhân kinh doanh</em
        ></strong
      >
    </p>
    <p>
      a. Người TTLK được lựa chọn kỳ đối soát Phí Hoa Hồng với các khoảng thời
      gian: theo từng ngày, 7 ngày, 15 ngày hoặc 30 ngày (“Kỳ Đối Soát”) và có
      thể thay đổi cài đặt Kỳ Đối Soát này tối đa 1 lần trong tháng. Kỳ Đối Soát
      mới sẽ được điều chỉnh kể từ ngày liền sau ngày có thay đổi cài đặt.
    </p>
    <p>
      b. Khi muốn rút Phí Hoa Hồng, Người TTLK cần xuất dữ liệu biên bản đối
      soát theo từng Kỳ Đối Soát. Trong vòng 15 ngày, Người TTLK có trách nhiệm
      tải lên Tài khoản TTLK (các) hóa đơn (bản điện tử, định dạng “.xml”) có
      giá trị tương ứng với (các) khoản Phí Hoa Hồng của từng lần đối soát. Quá
      thời hạn này mà BiboMart không nhận được hóa đơn thì (các) khoản Phí Hoa
      Hồng đã đối soát sẽ bị hủy, không còn giá trị chi trả.
    </p>
    <p>
      c. Trong vòng 3-5 ngày tiếp theo kể từ ngày BiboMart nhận được hóa đơn và
      không có bất kỳ phát sinh nào liên quan đến tính hợp lý và hợp lệ của hóa
      đơn, Người TTLK có thể rút được Phí Hoa Hồng về tài khoản ngân hàng đã
      đăng ký.
    </p>
    <p>
      <strong><em>(iii) Trường hợp Người TTTLK là doanh nghiệp</em></strong>
    </p>
    <p>
      a. Thực hiện tương tự như quy định đối với Người TTLK là hộ kinh doanh, cá
      nhân kinh doanh tại điểm (ii) Mục 3.3.2 nêu trên.
    </p>
    <p>
      b. Người TTLK sẽ chỉ rút được Phí Hoa Hồng sau khi tải lên hóa đơn giá trị
      gia tăng (bản điện tử, định dạng “.xml”) tương ứng với số liệu tại biên
      bản đối soát theo từng Kỳ Đối Soát được ghi nhận.
    </p>
    <p>
      c. Hóa đơn của Phí Hoa Hồng theo từng Kỳ Đối Soát là số tiền đã bao gồm
      thuế giá trị gia tăng với mức thuế suất theo quy định của pháp luật tại
      thời điểm xuất hóa đơn.
    </p>
    <p>
      <strong>3.4. Bồi hoàn và Cấn trừ</strong>
    </p>
    <p>
      (i) Người TTLK đồng ý rằng BiboMart có quyền thu hồi và cấn trừ bất kỳ
      khoản thanh toán phải trả cho Người TTLK; (ii) tổng số tiền thanh toán cho
      khoảng thời gian kể từ khi phát hiện vi phạm; và (iii) bất kỳ khoản lợi
      ích nào của Người TTLK mà được chứng minh là bắt nguồn từ hành vi không
      tuân thủ hoặc vi phạm hoặc liên quan đến Giao Dịch Thành Công.
    </p>
    <p>
      (ii) BiboMart sẽ không chi trả Phí Hoa Hồng và có quyền bù trừ hoặc thực
      hiện việc bồi hoàn cho BiboMart đối với các giao dịch đã được thanh toán
      trước đó (bao gồm việc yêu cầu Người TTLK hoàn trả lại cho BiboMart các
      khoản đã được thanh toán trước đó). Các giao dịch này bao gồm, nhưng không
      giới hạn ở:
    </p>
    <p>a. không đáp ứng đủ điều kiện của một Giao dịch Thành Công;</p>
    <p>b. có sự gian lận được phát hiện bởi BiboMart;</p>
    <p>
      c. được thực hiện thông qua sự thông đồng trên cơ sở nhãn hàng, nhà cung
      cấp có liên quan đến Người TTLK hoặc Người TTLK mua Sản Phẩm thông qua
      Link TTLK của mình;
    </p>
    <p>d. mua hàng ở Nền tảng BiboMart nhằm mục đích phân phối lại;</p>
    <p>
      e. bị hủy bỏ, không hoàn tất, bị trả hàng hoàn tiền theo chính sách của
      BiboMart;
    </p>
    <p>f. được thực hiện thông qua Link TTLK có chứa Nội Dung Cấm; và</p>
    <p>g. theo quy định của BiboMart tại từng thời điểm.</p>
    <p>
      <strong>3.5. Nghĩa vụ thuế đối với Người Tiếp thị Liên kết</strong>
    </p>
    <p>
      Người TTLK phải chịu trách nhiệm kê khai và chi trả tất cả các loại thuế,
      phí và lệ phí liên quan đến Thỏa thuận TTLK này (bao gồm nhưng không hạn
      chế ở thuế thu nhập cá nhân theo pháp luật Việt Nam). Nếu pháp luật liên
      quan có yêu cầu BiboMart phải khấu trừ bất kỳ khoản thuế nào từ các khoản
      tiền phải trả cho Người TTLK, BiboMart sẽ khấu trừ khoản tiền thuế phải
      thanh toán và cung cấp cho Người TTLK tài liệu chứng minh việc khấu
      trừ/nộp thuế.
    </p>
    <p>
      <strong>4. TRÁCH NHIỆM CỦA BIBOMART</strong>
    </p>
    <p>
      <strong>4.1. Vận hành Nền tảng BiboMart</strong>
    </p>
    <p>
      Vận hành và đảm bảo hoạt động ổn định của Nền tảng BiboMart, không gây ra
      các ảnh hưởng đến hiệu lực và khả năng thi hành của Thỏa thuận Tiếp thị
      Liên kết này đối với Người Tiếp thị liên kết.
    </p>
    <p>
      <strong>4.2. Sửa đổi, bổ sung Thỏa thuận Tiếp thị Liên kết</strong>
    </p>
    <p>
      (i) Nền tảng BiboMart sẽ không ngừng được thay đổi và cải tiến kỹ thuật.
      Do đó, BiboMart bảo toàn quyền sửa đổi, bổ sung nội dung Thỏa thuận Tiếp
      thị Liên kết này và/hoặc Điều khoản Tiếp thị Liên kết tại bất kỳ thời điểm
      nào để phù hợp với quy tắc vận hành của Nền tảng BiboMart nhưng không trái
      với quy định pháp luật. Nội dung thay đổi sẽ được BiboMart thông báo cập
      nhật tới Người TTLK ít nhất là 10 ngày trước thời điểm áp dụng chính thức
      trên Website/qua Email/thông báo trên Tài khoản TTLK.
    </p>
    <p>
      (ii) Trong trường hợp không đồng ý với các nội dung được sửa đổi, bổ sung,
      Người TTLK có thể thực hiện các thủ tục chấm dứt tư cách Người TTLK theo
      quy định tại Mục 9 Thỏa thuận TTLK này.
    </p>
    <p>
      <strong>4.3. Hủy, từ chối, gỡ bỏ</strong>
    </p>
    <p>
      (i) BiboMart có quyền xem xét và yêu cầu Người TTLK cung cấp bất kỳ Link
      TTLK và/hoặc Nội Dung TTLK nào cũng như bất kỳ tài liệu liên quan nào được
      Người TTLK sử dụng trong quá trình tham gia Chương trình Tiếp thị Liên kết
      BiboMart. BiboMart có quyền quyết định nếu nhận thấy:
    </p>
    <p>
      a. Người TTLK hoặc Nội Dung TTLK vi phạm Điều khoản Tiếp thị Liên kết;
    </p>
    <p>
      b. Người TTLK vi phạm hoặc khuyến khích việc vi phạm bất kỳ quy định pháp
      luật có liên quan nào;
    </p>
    <p>
      c. Người TTLK có các hành vi tiềm ẩn rủi ro làm phát sinh các trách nhiệm
      hình sự, dân sự hoặc hành chính đối với BiboMart;
    </p>
    <p>
      d. Bất kỳ Link TTLK và/hoặc Nội Dung TTLK có chứa nội dung cấm như quy
      định tại Mục 5.1 Thỏa thuận TTLK này;
    </p>
    <p>
      e. Người TTLK có các hành vi cấu kết, thông đồng với bên thứ ba để thực
      hiện các hoạt động gian dối, lừa đảo đối với Chương trình Tiếp thị Liên
      kết BiboMart nhằm mục đích mưu lợi cá nhân hoặc chiếm đoạt tiền và/hoặc
      các lợi ích vật chất từ BiboMart.
    </p>
    <p>
      (ii) Theo đó, BiboMart sẽ có toàn quyền thực hiện một hoặc một số hoặc tất
      cả các biện pháp sau:
    </p>
    <p>
      a. Yêu cầu Người TTLK ngay lập tức gỡ bỏ Link TTLK và/hoặc Nội Dung TTLK
      vi phạm;
    </p>
    <p>
      b. Yêu cầu Người TTLK khắc phục vi phạm hoặc việc không tuân thủ trong
      thời hạn nhất định;
    </p>
    <p>c. Yêu cầu Người TTLK bồi thường hoặc bồi hoàn cho BiboMart;</p>
    <p>
      d. Thu hồi Phí Hoa Hồng, các khoản thanh toán bằng tiền hoặc tương đương
      tiền, tài sản, chi phí vận chuyển, và các khoản phí khác mà Người TTLK có
      được từ hành vi vi phạm;
    </p>
    <p>
      e. Tiến hành khiếu nại bồi thường thiệt hại và/hoặc áp dụng các biện pháp
      khẩn cấp tạm thời;
    </p>
    <p>f. Hủy bỏ Thỏa thuận TTLK này.</p>
    <p>
      <strong>5. NGHĨA VỤ CỦA NGƯỜI TIẾP THỊ LIÊN KẾT</strong>
    </p>
    <p>
      <strong>5.1. Tuân thủ</strong>
    </p>
    <p>
      Người TTLK cam kết tuân thủ quy định tại Thỏa thuận Thỏa thuận Tiếp thị
      Liên kết này và Điều khoản Tiếp thị Liên kết và các điều kiện/tiêu chuẩn
      khác theo yêu cầu của BiboMart, gồm: nội dung, điều kiện kỹ thuật, yêu cầu
      về bảo mật, yêu cầu về trải nghiệm của người dùng, và yêu cầu liên quan
      đến hình ảnh của BiboMart trên phương tiện thông tin đại chúng
    </p>
    <p>
      <strong>5.2. Nội Dung TTLK bị cấm</strong>
    </p>
    <p>Nội Dung TTLK bị cấm bao gồm nhưng không giới hạn ở các nội dung:</p>
    <p>
      (i) chứa, hoặc có thể chứa, vi-rút, mã độc máy tính hoặc các thành phần có
      khả năng gây hại khác có thể đe dọa, lây nhiễm, làm hỏng hoặc can thiệp
      vào Nền tảng BiboMart;
    </p>
    <p>(ii) tạo ra hoặc có nguy cơ tạo ra rủi ro hoặc lỗ hổng bảo mật;</p>
    <p>
      (iii) sử dụng Link TTLK hoặc các thông tin của BiboMart để thực hiện việc
      quảng cáo trên các diễn đàn, group, website, trang mạng xã hội... của các
      Nhà cung cấp đối thủ (đăng bài, bình luận, chia sẻ, ...);
    </p>
    <p>
      (iv) cung cấp các thông tin sai lệch, không đầy đủ nhằm tiếp cận, thu hút
      Khách Hàng;
    </p>
    <p>
      (v) chia sẻ, quảng cáo thông tin trên các trang có nội dung độc hại, vi
      phạm đạo đức và vi phạm pháp luật, group cấm gây thiệt hại đến BiboMart;
    </p>
    <p>
      (vi) vi phạm bất kỳ Quyền Sở Hữu Trí Tuệ nào hoặc các quyền, bao gồm quyền
      sở hữu, của bất kỳ bên thứ ba nào;
    </p>
    <p>(vii) chứa các thông tin:</p>
    <p>+ sai lệch, không chính xác, gây hiểu lầm;</p>
    <p>+ phỉ bang, bối nhọ, quấy rối hoặc đe dọa, khuyến khích bạo lực;</p>
    <p>
      + các vấn đề nhạy cảm liên quan đến chính tri, chủ quyền lãnh thổ, giới
      tính, tôn giáo, quốc tịch, tình trạng khuyết tật;
    </p>
    <p>
      + tục tĩu, khiêu dâm, khiếm nhã, thô tục, bạo lực, giả mạo, lừa đảo, trái
      phép, có hại hoặc bất hợp pháp theo quy định pháp luật hiện hành hoặc trái
      với thông lệ xã hội và đạo đức;
    </p>
    <p>
      (viii) bất kỳ nội dung nào khác bị cấm theo các quy tắc và chính sách của
      BiboMart theo từng thời điểm.
    </p>
    <p>
      <strong>5.3. Các hành vi cấm thực hiện</strong>
    </p>
    <p>
      Người TTLK không được phép thực hiện các hành vi sau đây (gọi chung là
      “<strong>Hành vi Cấm</strong>”):
    </p>
    <p>
      (i) sử dụng bất kỳ các kênh liên kết thứ cấp, bên thứ ba hoặc bất kỳ
      phương pháp nào không thuộc phạm vi Thỏa thuận TTLK để thực hiện tiếp thị
      liên kết mà chưa được BiboMart chấp thuận bằng văn bản;
    </p>
    <p>
      (ii) Link TTLK được gắn với Nội Dung TTLK có chứa Nội Dung TTLK bị cấm,
      hoặc ở các trang web torrent hoặc trang nội dung trực tuyến;
    </p>
    <p>
      (iii) thực hiện hành vi gây phương hại: (a) đến BiboMart và/hoặc các quyền
      của bên liên kết của BiboMart hoặc đến Quyền Sở hữu Trí Tuệ của BiboMart
      và/hoặc các bên liên kết của BiboMart; hoặc (b) đến danh tiếng, hình ảnh,
      giá trị hoặc thiện chí của BiboMart và/hoặc bên liên kết của BiboMart;
    </p>
    <p>
      (iv) thực hiện bất kỳ hành vi nào, dù trực tiếp hay gián tiếp, cố ý hay vô
      ý, theo quan điểm của BiboMart, là gian lận và nhằm thu lợi bằng chi phí
      của BiboMart (vượt quá phạm vi của Thỏa thuận TTLK này) khi tham gia
      Chương trình Tiếp thị Liên kết BiboMart;
    </p>
    <p>
      (v) vi phạm SEM brandname, chạy từ khóa thương hiệu “BiboMart” ảnh hưởng
      đến thương hiệu, gây tổn hại đến BiboMart, chi tiết: (a) quảng cáo từ khóa
      thương hiệu “BiboMart” trên các công cụ tìm kiếm (Google Adwords, Cốc Cốc,
      Bing…); và (b) sử dụng các dạng biến thể thương hiệu hoặc các từ khóa có
      chứa thương hiệu “BiboMart”;
    </p>
    <p>
      (vi) kết hợp, tiến hành các hoạt động như cờ bạc, rút thăm trúng thưởng,
      xổ số hoặc bất kỳ hành vi trái pháp luật, vi phạm đạo đức hoặc chống đối
      xã hội nào khác trên Nội Dung TTLK;
    </p>
    <p>
      (vii) thực hiện bất kỳ việc quảng cáo đối với các chất cấm, dịch vụ, sản
      phẩm, hoặc tài liệu/nội dung vi phạm pháp luật;
    </p>
    <p>
      (viii) sử dụng email quảng cáo để quảng bá cho BiboMart khi chưa được chấp
      thuận bằng văn bản;
    </p>
    <p>
      (ix) sử dụng các công cụ, phương tiện, phương pháp nhằm chuyển đổi Khách
      Hàng với mục đích lừa đảo;
    </p>
    <p>
      (x) sử dụng bất kỳ phương tiện tự động hoặc hình thức thu thập thông tin
      từ các nguồn thông tin công cộng hoặc các phương pháp thu thập thông tin
      khác để đăng nhập, thao tác, thu thập, hoặc sử dụng bất cứ thông tin nào
      trên Nền tảng BiboMart, bao gồm nhưng không giới hạn Sản Phẩm được đăng
      bán, giá bán, lịch sử thay đổi giá bán theo từng phân loại, các Quyền Sở
      Hữu Trí Tuệ của BiboMart, bao gồm logo, hình ảnh chủ đạo, tài liệu sáng
      tạo, và các Thông Tin Mật khác dù là trong hay ngoài Nền tảng BiboMart;
    </p>
    <p>(xi) quảng cáo mạo danh BiboMart dưới mọi hình thức.</p>
    <p>
      <strong>5.4. Miễn trừ, bồi thường và giới hạn trách nhiệm</strong>
    </p>
    <p>
      Người TTLK sẽ bồi thường và giữ cho BiboMart (bao gồm cả nhân viên, công
      ty con, đối tác, nhà cung cấp, nhà thầu, đơn vị liên kết của BiboMart)
      không bị tổn hại và theo lựa chọn của BiboMart, bảo vệ BiboMart khỏi tất
      cả khiếu nại, thiệt hại, trách nhiệm pháp lý, tổn thất, chi phí và phí tổn
      (bao gồm phí pháp lý và phí dịch vụ hợp lý khác) (“Khiếu Nại”) phát sinh
      từ hoặc liên quan đến:
    </p>
    <p>
      (i) vi phạm quy đinh theo Thỏa thuận TTLK này và/hoặc Điều khoản TTLK được
      thông báo tại từng thời điểm;
    </p>
    <p>
      (ii) bất kỳ thông tin không chính xác, sai lệch hoặc sai sót nào được cung
      cấp cho BiboMart hoặc bất kỳ bên thứ ba nào liên quan đến việc hoạt động
      theo Thỏa thuận TTLK này;
    </p>
    <p>
      (iii) bất kỳ chi phí tuân thủ thuế hoặc nghĩa vụ thuế nào phát sinh bởi
      BiboMart liên quan đến các hoạt động của Người TTLK, phát sinh từ việc
      Người TTLK không tuân thủ quy định pháp luật thuế hiện hành hoặc do
      BiboMart được xem là đại lý thuế của Người TTLK;
    </p>
    <p>
      (iv) bất kỳ hành vi vi phạm thực tế hoặc bị cáo buộc nào đối với Quyền Sở
      Hữu Trí Tuệ của BiboMart hoặc bên thứ ba.
    </p>
    <p>
      <strong>6. QUYỀN SỞ HỮU TRÍ TUỆ</strong>
    </p>
    <p>
      6.1. “<strong>Quyền Sở hữu Trí tuệ</strong>” / “<strong>Quyền SHTT</strong
      >” có nghĩa là tất cả quyền tác giả, sáng chế, thương hiệu, nhãn hiệu, tên
      miền, quyền thiết kế bố trí, thiết kế đã đăng ký, quyền thiết kế, quyền cơ
      sở dữ liệu, tên thương mại hoặc tên doanh nghiệp, quyền bảo vệ bí mật
      thương mại và thông tin bí mật, quyền bảo vệ uy tín và danh tiếng, và tất
      cả các quyền sở hữu tương tự hoặc tương ứng khác và tất cả hồ sơ đăng ký
      tương tự, dù hiện hữu hay được tạo ra trong tương lai, ở bất kỳ đâu trên
      thế giới, dù đã đăng ký hay chưa đăng ký, và tất cả các lợi ích, đặc
      quyền, quyền khởi kiện, bồi thường thiệt hại và thực hiện biện pháp tạm
      thời đối với bất kỳ hành vi xâm hại, chiếm đoạt hoặc vi phạm bất kỳ quyền
      nào trên đây trong quá khứ, hiện tại hoặc tương lai.
    </p>
    <p>
      6.2. BiboMart bảo toàn các quyền sở hữu trí tuệ đối với Nền tảng BiboMart
      cung cấp cho Người TTLK theo Thỏa thuận TTLK này, bao gồm thông tin, hình
      ảnh, logo, video, nhãn hiệu thương mại của BiboMart, các tài liệu kỹ
      thuật, tài liệu - video tập huấn nghiệp vụ/hướng dẫn sử dụng, … (gọi chung
      là “<strong>Tài sản SHTT</strong>”) được BiboMart cung cấp.
    </p>
    <p>
      6.3. Người TTLK chỉ được sử dụng Tài sản SHTT nhằm mục đích tiếp thị liên
      kết theo phạm vi Thỏa thuận TTLK này. Mọi hành vi trái với mục đích của
      Thỏa thuận TTLK này đều không được phép thực hiện, ngoại trừ khi được sự
      đồng ý bằng văn bản của BiboMarrt.
    </p>
    <p>
      6.4. Quy định tại Mục 6.2 và 6.3 cũng được áp dụng được với tài sản sở hữu
      trí tuệ của các nhãn hàng, Sản Phẩm có trên Nền tảng BiboMart.
    </p>
    <p>
      <strong>7. BẢO MẬT THÔNG TIN</strong>
    </p>
    <p>
      7.1. “<strong>Thông Tin Mật</strong>” là những thông tin bao gồm nhưng
      không giới hạn ở (i) bất kỳ thông tin không công khai nào của một bên
      trong Thỏa thuận TTLK này được tiết lộ bởi một bên cho bên còn lại bằng
      văn bản, hình ảnh, ký tự máy móc, hoặc bất kỳ hình thức hiện hữu nào và
      được đánh dấu “Mật” hoặc “Không Công Khai” hoặc đánh dấu/ghi chú theo cách
      khác để thể hiện bản chất mật của thông tin; (ii) các tài liệu của
      BiboMart và tất cả các thông tin truyền thông hoặc kỹ thuật không công
      khai của BiboMart, cho dù có được thể hiện rõ là Thông Tin Mật hay không;
      và (iii) tất cả các thông tin được thu thập hoặc phát triển bởi Shopee
      liên quan đến người dùng của BiboMart. Thông Tin Mật cũng bao gồm các tiết
      lộ bằng lời nói nếu thông tin đó được hiểu một cách hợp lý là thông tin
      mật thông qua ngữ cảnh hoặc bối cảnh của việc tiết lộ.
    </p>
    <p>
      7.2. Thông Tin Mật sẽ không bao gồm các thông tin: (i) là thông tin công
      cộng trước thời điểm bên tiết lộ cung cấp thông tin đó; (ii) là thông tin
      được bên tiết lộ cung cấp cho bên nhận thông tin và sau đó trở thành thông
      tin công cộng mà không phải do tác động hoặc sự không can thiệp của bên
      nhận thông tin; (iii) là thông tin thuộc quyền sở hữu hợp pháp của bên
      nhận thông tin vào thời điểm cung cấp thông tin; (iv) được tiếp nhận từ
      một bên thứ ba mà không xuất phát từ việc bên thứ ba vi phạm nghĩa vụ bảo
      mật của mình; (v) được phát triển một cách độc lập bởi bên nhận thông tin
      mà không sử dụng hay dẫn chiếu đến Thông Tin Mật của bên tiết lộ thông
      tin; hoặc (vi) được tiết lộ bởi bên tiếp nhận thông tin theo sự chấp thuận
      trước bằng văn bản của bên tiết lộ thông tin.
    </p>
    <p>7.3. Các Bên cam kết:</p>
    <p>(i) bảo mật tất cả Thông Tin Mật của bên còn lại;</p>
    <p>
      (ii) không tiết lộ Thông Tin Mật cho bất kỳ bên thứ ba nào, trừ trường hợp
      buộc phải biết cho các bên thứ ba đã ký thỏa thuận bảo mật chứa các nội
      dung về bảo mật tương tự như tại Mục 7 này và bên đó đã đạt được chấp
      thuận bằng văn bản cho việc tiết lộ thông tin từ bên cung cấp Thông Tin
      Mật; và
    </p>
    <p>
      (iii) không sử dụng Thông Tin Mật trừ khi liên quan đến việc thực hiện các
      nghĩa vụ hoặc hoặc các quyền theo Thỏa thuận TTLK này. Mỗi Bên được phép
      tiết lộ Thông Tin Mật của bên còn lại nếu việc cung cấp thông tin là bắt
      buộc theo quy định pháp luật miễn là bên còn lại được thông báo trước bằng
      văn bản về nghĩa vụ cung cấp thông tin đó trước khi việc cung n cấp thông
      tin diễn ra và hỗ trợ trong việc ngăn chặn thông tin đó bị đăng tải công
      khai.
    </p>
    <p>
      <strong>8. BẢO VỆ DỮ LIỆU CÁ NHÂN</strong>
    </p>
    <p>
      8.1. Thông tin được BiboMart yêu cầu Người TTLK cung cấp trong quá trình
      tham gia Chương trình Tiếp thị Liên kết BiboMart được BiboMart sử dụng và
      bảo vệ dữ liệu cá nhân theo quy định tại <a href="https://bibomart.com.vn/bao-mat-thong-tin-ca-nhan.html"> Chính sách Quyền riêng tư và Bảo mật thông tin</a>.
    </p>
    <p>
      8.2. Người TTLK cam kết truy cập và sử dụng Nền tảng BiboMart, Tài khoản
      TTLK cũng như việc tham gia Chương trình Tiếp thị Liên kết BiboMart tuân
      thủ theo <a href="https://bibomart.com.vn/bao-mat-thong-tin-ca-nhan.html" > Chính sách Quyền riêng tư và Bảo mật thông tin</a>
      được công khai trên Nền tảng BiboMart (được sửa đổi, bổ sung theo từng
      thời điểm) là một phần của Thỏa thuận TTLK này bằng cách dẫn chiếu tại
      đây.
    </p>
    <p>
      <strong>9. CHẤM DỨT TƯ CÁCH NGƯỜI TIẾP THỊ LIÊN KẾT</strong>
    </p>
    <p>
      <strong>9.1. Đơn phương chấm dứt</strong>
    </p>
    <p>
      Mỗi Bên có thể đơn phương chấm dứt Điều khoản TTLK này bằng cách gửi cho
      bên còn lại một thông báo bằng văn bản trước ít nhất 7 ngày làm việc.
    </p>
    <p>
      <strong>9.2. Quyền chấm dứt của BiboMart</strong>
    </p>
    <p>
      BiboMart có thể đơn phương và ngay lập tức chấm dứt Thỏa thuận TTLK
      và/hoặc đình chỉ, hạn chế hoặc chấm dứt việc Người TTLK tham gia Chương
      trình Tiếp thị Liên kết BiboMart và/hoặc việc sử dụng Nền tảng BiboMart mà
      không cần phải thông báo trước khi Người TTLK vi phạm các nghĩa vụ được
      quy định tại Mục 4.3 hoặc có Sự Kiện Bất Khả Kháng. Theo đó, các khoản Phí
      Hoa hồng có thể được BiboMart thanh toán cho Người TTLK có thể được xem là
      khoản tiền bồi hoàn mà không làm ảnh hưởng tới quyền hoặc các biện pháp
      khắc phục khác dược BiboMart áp dụng.
    </p>
    <p>
      <strong>9.3. Các trường hợp chấm dứt khác</strong>
    </p>
    <p>
      (i) Một Bên rơi vào tình trạng giải thể, phá sản, tạm ngừng hoạt động kinh
      doanh;
    </p>
    <p>
      (ii) Sự Kiện Bất Khả Kháng theo quy định tại Mục 13.2 Thỏa thuận TTLK này.
    </p>
    <p>
      <strong>9.4. Hậu quả của việc chấm dứt</strong>
    </p>
    <p>
      Sau khi chấm dứt Thỏa thuận TTLK vì bất kỳ lý do nào, Người TTLK sẽ ngay
      lập tức ngừng việc sử dụng tất các Link TTLK của BiboMart, và sẽ ngừng
      việc thể hiện mình là Người TTLK của BiboMart.
    </p>
    <p>
      <strong
        >9.5. Hiệu lực của Thỏa thuận Tiếp thị liên kết sau khi chấm dứt</strong
      >
    </p>
    <p>
      Các quy định tại Mục 1, 3, 7, 9, 10, 11, 12, 13 và mọi trách nhiệm pháp lý
      chưa hoàn thành cộng dồn đến trước khi Thỏa thuận TTLK chấm dứt hoặc hết
      hạn sẽ tiếp tục có hiệu lực sau khi Thỏa thuận TTLK đã chấm dứt hiệu lực
      hoặc hết hạn
    </p>
    <p>
      <strong>10. GIỚI HẠN TRÁCH NHIỆM PHÁP LÝ</strong>
    </p>
    <p>
      <strong>10.1. Miễn trừ trách nhiệm</strong>
    </p>
    <p>
      (i) TẤT CẢ CÁC TÀI LIỆU VÀ ĐƯỜNG LINK TIẾP THỊ LIÊN KẾT CỦA BIBOMART ĐƯỢC
      CUNG CẤP TRÊN NGUYÊN TẮC “CÓ SẴN”. NGƯỜI TIẾP THỊ LIÊN KẾT CÔNG NHẬN VÀ
      ĐỒNG Ý RẰNG BIBOMART SẼ KHÔNG CÓ TRÁCH NHIỆM PHÁP LÝ CHO BẤT KỲ HƯ HỎNG
      NÀO CỦA HỆ THỐNG HAY QUY TRÌNH BẢO VỆ/BẢO MẬT. BIBOMART KHÔNG BẢO ĐẢM RẰNG
      TÀI LIỆU TỪ BIBOMART HOẶC CÁC ĐƯỜNG LINK TIẾP THỊ LIÊN KẾT ĐƯỢC CUNG CẤP
      SẼ CÓ SẴN, CÓ THỂ TRUY CẬP ĐƯỢC, KHÔNG BỊ GIÁN ĐOẠN, BẢO MẬT, CHÍNH XÁC,
      HOÀN CHỈNH HOẶC KHÔNG CÓ LỖI, VÀ CÁC LỖI (NẾU CÓ) SẼ ĐƯỢC ĐIỀU CHỈNH HOẶC
      CÓ HỆ THỐNG SERVER CÓ THỂ THỰC HIỆN CÁC CHỨC NĂNG CÓ TƯƠNG TỰ MÀ KHÔNG
      CHỨA VIRUS, CLOCKS, TIMERS, COUNTERS, WORMS, SOFTWARE LOCKS, DROPDEAD
      DEVICES, TROJAN-HORSES, ROUTING, TRAP DOORS, TIME BOMBS HOẶC BẤT KỲ ĐOẠN
      MÃ, HƯỚNG DẪN, CHƯƠNG TRÌNH HOẶC CÁC LINH KIỆN ĐỘC HẠI NÀO.
    </p>
    <p>
      (ii) DÙ DƯỚI BẤT KỲ TRƯỜNG HỢP NÀO, BIBOMART SẼ KHÔNG CHỊU TRÁCH NHIỆM ĐỐI
      VỚI NGƯỜI TIẾP THỊ LIÊN KẾT VỀ CÁC HẬU QUẢ, SỰ CỐ, TÌNH HUỐNG ĐẶC BIỆT,
      TRÁCH NHIỆM, PHÁT SINH TỪ HOẶC LIÊN QUAN ĐẾN GIAO DỊCH THEO THỎA THUẬN
      TIẾP THỊ LIÊN KẾT NÀY, BAO GỒM NHỮNG TỔN THẤT LỢI NHUẬN HOẶC KINH DOANH.
    </p>
    <p>
      <strong>10.2. Giới hạn trách nhiệm</strong>
    </p>
    <p>
      Trong mọi trường hợp, tổng trách nhiệm pháp lý của BiboMart phát sinh từ
      hoặc liên quan đến Thỏa thuận TTLK này (bao gồm các điều khoản bảo đảm),
      bất kể lãnh thổ áp dụng, bất kể hành động/khiếu nại nào dựa trên hay ngoài
      hợp đồng, sẽ không vượt quá tổng số tiền BiboMart đã thanh toán hoặc phải
      thanh toán cho Người TTLK theo Thỏa thuận TTLK này cho giai đoạn 6 tháng
      liền trước khiếu nại đó.
    </p>
    <p>
      <strong>11. LUẬT ĐIỀU CHỈNH VÀ GIẢI QUYẾT TRANH CHẤP</strong>
    </p>
    <p>
      11.1. Thỏa thuận TTLK này sẽ được điều chỉnh và giải thích theo luật pháp
      của Việt Nam.
    </p>
    <p>
      11.2. Trong trường hợp có bất kỳ tranh chấp, yêu cầu, hoặc bất đồng nào
      giữa các Bên liên quan đến Thỏa thuận TTLK này, bao gồm vi phạm, hủy bỏ,
      hay hiệu lực của Thỏa thuận TTLK, hoặc liên quan đến bất kỳ vấn đề nào cần
      phải có sự cân nhắc khách quan theo Thỏa thuận TTLK này (“<strong
        >Tranh Chấp</strong
      >”), Tranh Chấp đó đã được một bên thông báo cho bên còn lại bằng văn bản
      (“<strong>Thông Báo Tranh Chấp</strong>”), các bên sẽ nỗ lực giải quyết
      Tranh Chấp bằng thương lượng giữa quản lý cấp cao của các bên trong vòng
      30 ngày kể từ ngày một Bên nhận được Thông Báo Tranh Chấp. Nếu Tranh Chấp
      không thể được giải quyết bằng thương lượng trong thời hạn này, tranh chấp
      đó sẽ được đưa ra giải quyết tại Trung tâm Trọng tài Quốc tế Việt Nam
      (VIAC) theo Quy tắc tố tụng trọng tài của Trung tâm này. Hội đồng trọng
      tài sẽ bao gồm 03 trọng tài và ngôn ngữ phân sử là tiếng Việt.
    </p>
    <p>
      <strong>12. TUYÊN BỐ VÀ BẢO ĐẢM</strong>
    </p>
    <p>
      <strong>12.1. Tuyên bố và Đảm bảo chung</strong>
    </p>
    <p>Mỗi Bên tuyên bố và đảm bảo rằng:</p>
    <p>
      (i) Có đầy đủ tư cách pháp lý, năng lực dân sự và hoạt động hợp pháp theo
      quy định;
    </p>
    <p>
      (ii) Việc ký Thỏa thuận TTLK này được ủy quyền hợp pháp và hợp lệ (nếu
      có);
    </p>
    <p>
      (iii) Thỏa thuận TTLK xác lập một nghĩa vụ có giá trị ràng buộc các bên
      ngay tại thời điểm các bên giao ước; và
    </p>
    <p>
      (iv) Nghiêm túc tuân thủ mọi quy định pháp luật có liên quan khi thực hiện
      Thỏa thuận TTLK này.
    </p>
    <p>
      <strong>12.2. Tuyên bố và Đảm bảo của Người Tiếp thị Liên kết</strong>
    </p>
    <p>
      (i) Việc ký kết và thực hiện Thỏa Thỏa thuận TTLK này sẽ không trái với
      hoặc cấu thành một vi phạm đối với bất kỳ hợp đồng, văn kiện, phán quyết,
      hoặc bất kỳ quy định pháp luật hoặc chỉ thị của cơ quan nhà nước có thẩm
      quyền nào áp dụng cho Người TTLK;
    </p>
    <p>
      (ii) Mọi thông tin cung cấp cho BiboMart là đầy đủ, trung thực, chính xác
      và mới nhất; và Người TTLK có quyền thực hiện hoạt động theo phạm vi Điều
      khoản TTLK;
    </p>
    <p>
      (iii) Nội dung đi kèm Link TTLK không chứa (a) bất kỳ thông tin nào vi
      phạm hoặc khuyến khích vi phạm bất kỳ luật áp dụng nào, (b) thông tin hoặc
      động cơ lừa đảo hoặc lừa dối, (c) virus, malware, spyware, Trojan,
      phishing, hoặc bất kỳ mã độc nào có thể phá vỡ hoặc vượt qua bất kỳ biện
      pháp bảo vệ Nền tảng BiboMart nào, (e) thông tin truyền thông hoặc giới
      thiệu hàng giả, hàng nhái hoặc các nội dung vi phạm pháp luật (bao gồm các
      ứng dụng di động hoặc phần mềm có chứa các loại phí ẩn), (f) bất kỳ tài
      liệu nào vi phạm các quyền của bất kỳ bên thứ ba nào; hoặc (g) bất kỳ tài
      liệu nào có hại, chứa nội dung khiêu dâm hoặc không phù hợp, hoặc mang
      tính xúc phạm.
    </p>
    <p>
      <strong>13. ĐIỀU KHOẢN CHUNG</strong>
    </p>
    <p>
      <strong>13.1. Chuyển nhượng quyền và nghĩa vụ</strong>
    </p>
    <p>
      (i) Người TTLK sẽ không chuyển giao bất kỳ quyền hoặc nghĩa vụ nào trong
      phạm vi Thỏa thuận TTLK này (dù là toàn bộ hay một phần), bao gồm trực
      tiếp hoặc gián tiếp, mà chưa được sự chấp thuận của BiboMart. BiboMart bảo
      lưu quyền từ chối chấp thuận giao dịch chuyển nhượng này của Người TTLK.
      Bất kỳ thay đổi trực tiếp hay gián tiếp về sở hữu phần vốn góp hoặc cổ
      phần trong công ty hoặc ban giám đốc hoặc quyền kiểm soát Người TTLK, cho
      dù Người TTLK sau đó có còn là một pháp nhân độc lập hay không, sẽ được
      xem là chuyển nhượng hoặc chuyển giao cần phải có chấp thuận trước của
      BiboMart bằng văn bản. Việc Người TTLK chuyển nhượng sẽ không làm giảm các
      nghĩa vụ của Người TTLK theo Thỏa thuận TTLK này và BiboMart sẽ không giải
      trừ trách nhiệm pháp lý của Người TTLK theo Thỏa thuận TTLK này trừ khi
      được BiboMart chấp thuận bằng văn bản.
    </p>
    <p>
      (ii) BiboMart có thể chuyển nhượng bất kỳ quyền và nghĩa vụ nào của mình
      theo Thỏa thuận TTLK này (dù là một phần hay toàn bộ) mà không cần chấp
      thuận của Người TTLK. Bất kỳ việc chuyển nhượng hoặc chuyển giao vi phạm
      của Mục này sẽ là vô hiệu. Tùy thuộc vào Mục này, Thỏa thuận TTLK này sẽ
      ràng buộc và chuyển giao vì quyền lợi của người kế thừa hoặc nhận chuyển
      giao được phép của mỗi bên.
    </p>
    <p>
      <strong>13.2. Sự Kiện Bất Khả Kháng</strong>
    </p>
    <p>
      Không bên nào phải chịu trách nhiệm với bên còn lại về bất kỳ việc không
      thực hiện hoặc trì hoãn hoàn thành một nghĩa vụ (ngoài nghĩa vụ tài chính)
      theo Thỏa thuận TTLK này nếu việc không thực hiện hoặc trì hoãn là do các
      sự kiện ngoài tầm kiểm soát, bao gồm bất kỳ sự cố cháy/nổ, mất điện, đình
      công, chiến tranh, hoặc hành động của chính phủ (bao gồm bất kỳ luật hoặc
      văn bản dưới luật mới) hoặc việc không thực hiện (“<strong
        >Sự Kiện Bất Khả Kháng</strong
      >”). Thời hạn để hoàn tất nghĩa vụ có liên quan sẽ được gia hạn thêm một
      khoảng thời gian tương đương với thời gian diễn ra Sự Kiện Bất Khả Kháng.
    </p>
    <p>
      <strong>13.3. Thông cáo báo chí</strong>
    </p>
    <p>
      Trừ khi được quy định rõ trong Thỏa thuận TTLK này hoặc theo quy định pháp
      luật có liên quan, không bên nào được đưa ra bất kỳ tuyên bố công khai
      hoặc thông cáo báo chí liên quan đến việc hợp tác theo Thỏa thuận TTLK này
      mà không được sự đồng ý trước của bên còn lại. Nếu một bên phải tuyên bố
      công khai theo quy định pháp luật liên quan đến việc hợp tác tại Thỏa
      thuận TTLK này sẽ thu thập và cân nhắc ý kiến của bên còn lại về nội dung
      của tuyên bố công khai đó.
    </p>
    <p>
      <strong>13.4. Thông báo</strong>
    </p>
    <p>
      Tất cả các thông báo theo Thỏa thuận TTLK này sẽ được xem là đã gửi vào
      ngày người nhận nhận bất kể là thông qua chuyển phát bưu điện, email, thư
      bảo đảm, fax, và gửi cho BiboMart hoặc Người TTLK theo địa chỉ của mỗi
      bên.
    </p>
    <p>
      <strong>13.5. Hiệu lực từng phần</strong>
    </p>
    <p>
      Nếu bất cứ điều khoản, điều kiện hay quy định của Thỏa thuận TTLK này bị
      phát hiện là không hợp lệ, trái phép hay không thể thực thi ở bất kỳ mức
      độ nào, các bên sẽ cố gắng một cách thiện chí để sửa đổi nhằm bảo toàn các
      ý định được thể hiện trong Thỏa Thuận này trong chừng mực có thể. Trong
      trường hợp các bên không đồng ý về việc sửa đổi, thì điều khoản, điều
      kiện, quy định không hợp lệ đó sẽ bị gỡ bỏ khỏi Thỏa thuận TTLK. Các điều
      khoản, điều kiện và quy định còn lại của Thỏa thuận Tiếp thị Liên kết sẽ
      tiếp tục có hiệu lực trong phạm vi tối đa được pháp luật cho phép, và sẽ
      được bảo lưu tới mức tối đa ý định ban đầu của các Bên đối với điều khoản,
      điều kiện hoặc điều khoản đã bị gỡ bỏ.
    </p>
    <p>
      <strong>14. LIÊN HỆ</strong>
    </p>
    <p>
      Liên hệ với Chúng tôi theo các phương thức dưới đây để được giải đáp bất
      kỳ câu hỏi, thắc mắc về Chương trình Tiếp thị Liên kết BiboMart:
    </p>
    <p>
      <strong>CÔNG TY CỔ PHẦN BIBOMART TM</strong>
    </p>
    <p>Địa chỉ : 120 Trần Duy Hưng, Phường Yên Hòa, Thành phố Hà Nội, Việt Nam</p>
    <p>
      Email : <a href="mailto:cskh@bibomart.com.vn">cskh@bibomart.com.vn</a>
    </p>
    <p>Hotline : 1800 6886</p>
    <p>
    <em>Phiên bản này có hiệu lực từ ngày 15/12/2023</em>
    </p>
          </div>
        </div>
      </Layout>
    )
}
export default Affiliate;